import ApiService from "./ApiService"

export default {
    get(id) {
        return ApiService().get(`api/defects/${id}`);
    },
    search(search) {
        let params = new URLSearchParams();
        if(search.output)
            params.append('output', search.output);
        if(search.search && search.search.length > 0)
            params.append('term', search.search);

        let qs = params.toString();
        if(qs && qs.length > 0)
            qs = "?" + qs;
        return ApiService().get(`api/defects/${search.offset}/${search.limit}${qs}`);
    },
    post(body) {
        return ApiService().post(`api/defects`, body);
    },
    put(id, body) {
        return ApiService().put(`api/defects/${id}`, body);
    },
    delete(id) {
        return ApiService().delete(`api/defects/${id}`, {});
    }
}